<template>
  <v-row dense style="min-height: 44px">
    <v-col cols="auto">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">{{ icon }}</v-icon>
        </template>
        {{ tooltip }}
      </v-tooltip>
    </v-col>
    <v-col cols="auto">
      <slot name="content" />
    </v-col>
    <v-col class="text-end">
      <slot name="actions" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
      default: "close",
    },
    tooltip: {
      type: String,
      required: true,
      default: "",
    },
  },

  data() {
    return {};
  },
};
</script>
